import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Color from '@bubble-dev/fantasy-color'; // @ts-expect-error

import { PropTypes } from 'prop-types'; // @ts-expect-error

import { mapObjIndexed, omit } from 'ramda';
import { transformColor } from '@bubble-ui/particle-colors'; // @ts-expect-error

import StyleSheetOverridesProvider from '@bubble-ui/provider-style-sheet-overrides';
import { getContext } from 'recompose'; // @ts-expect-error

import { ActionIconCheckmark } from './overrides/ActionIconCheckmark'; // @ts-expect-error

import { BoxSelectorOptionBase } from './overrides/BoxSelectorOptionBase'; // @ts-expect-error

import { ButtonPrimary } from './overrides/ButtonPrimary'; // @ts-expect-error

import { ButtonSecondary } from './overrides/ButtonSecondary'; // @ts-expect-error

import { ButtonTertiary } from './overrides/ButtonTertiary'; // @ts-expect-error

import { ButtonQuaternary } from './overrides/ButtonQuaternary'; // @ts-expect-error

import { FormElement } from './overrides/FormElement'; // @ts-expect-error

import { Link } from './overrides/Link'; // @ts-expect-error

import { ListItem } from './overrides/ListItem'; // @ts-expect-error

import { Preview } from './overrides/Preview'; // @ts-expect-error

import { RadioBullet } from './overrides/RadioBullet'; // @ts-expect-error

import { SelectorInput } from './overrides/SelectorInput'; // @ts-expect-error

import { SpacerVertical } from './overrides/SpacerVertical'; // @ts-expect-error

import { SwitchCheckbox } from './overrides/SwitchCheckbox'; // @ts-expect-error

import { SwitchToggle } from './overrides/SwitchToggle'; // @ts-expect-error

import { TitleSecondary } from './overrides/TitleSecondary'; // @ts-expect-error

import { Tooltip } from './overrides/Tooltip';
import SetThemeInContext from './SetThemeInContext';
import ThemeContext from './context';
var hovered = transformColor.hovered,
    pressed = transformColor.pressed;
export { default as ThemeContext } from './context';

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children,
      customOverrides = _ref.customOverrides;

  if (theme == null) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  var customizations = _objectSpread(_objectSpread({}, mapObjIndexed(function (v) {
    return new Color(v);
  }, omit(['radius_border'], theme))), theme.radius_border != null ? {
    radius_border: theme.radius_border
  } : {});

  var borderRadiusParsed = parseInt(customizations.radius_border, 10);
  var borderRadius = isNaN(borderRadiusParsed) ? undefined : borderRadiusParsed < 15 ? borderRadiusParsed : 15;
  var buttonColor = customizations.color_button;
  var buttonColorHovered = customizations.color_button != null ? hovered(customizations.color_button) : undefined;
  var buttonColorPressed = customizations.color_button != null ? pressed(customizations.color_button) : undefined;
  var buttonTextColor = customizations.color_button_text;
  var buttonTextColorHovered = customizations.color_button_text != null ? hovered(customizations.color_button_text) : undefined;
  var buttonTextColorPressed = customizations.color_button_text != null ? pressed(customizations.color_button_text) : undefined;
  var borderSelectedColor = customizations.color_border_selected;
  var borderColor = customizations.color_border;
  var checkboxColor = customizations.color_checkbox;
  var checkboxCheckmarkColor = customizations.color_checkbox_checkmark;
  var linkColor = customizations.color_link;
  var detailsColor = customizations.color_details;
  var headerColor = customizations.color_header;
  var spacerColor = customizations.color_spacer;
  var textColor = customizations.color_text;
  var textSecondaryColor = customizations.color_text_secondary;

  var overrides = _objectSpread({
    ActionIconCheckmark: ActionIconCheckmark({
      checkboxCheckmarkColor: checkboxCheckmarkColor
    }),
    BoxSelectorOptionBase: BoxSelectorOptionBase({
      borderColor: borderColor,
      borderSelectedColor: borderSelectedColor,
      borderRadius: borderRadius,
      textColor: textColor
    }),
    ButtonPrimary: ButtonPrimary({
      borderRadius: borderRadius,
      buttonColor: buttonColor,
      buttonColorHovered: buttonColorHovered,
      buttonColorPressed: buttonColorPressed,
      buttonTextColor: buttonTextColor
    }),
    ButtonSecondary: ButtonSecondary({
      borderRadius: borderRadius,
      buttonColor: buttonColor,
      buttonColorHovered: buttonColorHovered,
      buttonColorPressed: buttonColorPressed,
      buttonTextColor: buttonTextColor,
      buttonTextColorHovered: buttonTextColorHovered,
      buttonTextColorPressed: buttonTextColorPressed
    }),
    ButtonTertiary: ButtonTertiary({
      buttonColor: buttonColor,
      buttonColorHovered: buttonColorHovered,
      buttonColorPressed: buttonColorPressed
    }),
    ButtonQuaternary: ButtonQuaternary({
      borderRadius: borderRadius,
      buttonColor: buttonColor,
      buttonColorHovered: buttonColorHovered,
      buttonColorPressed: buttonColorPressed
    }),
    Dropdown: FormElement({
      borderSelectedColor: borderSelectedColor,
      borderRadius: borderRadius
    }),
    Field: FormElement({
      borderSelectedColor: borderSelectedColor,
      borderRadius: borderRadius
    }),
    LinkPrimary: Link({
      linkColor: linkColor
    }),
    LinkSecondary: Link({
      linkColor: linkColor
    }),
    ListItem: ListItem({
      detailsColor: detailsColor,
      textColor: textColor
    }),
    Preview: Preview({
      borderRadius: borderRadius
    }),
    PrimaryMerchantColorIcon: function PrimaryMerchantColorIcon() {
      return {
        pathStyle: {
          fill: customizations.color_link
        }
      };
    },
    RadioBullet: RadioBullet({
      checkboxColor: checkboxColor,
      checkboxCheckmarkColor: checkboxCheckmarkColor
    }),
    SelectorInput: SelectorInput({
      borderColor: borderColor,
      borderSelectedColor: borderSelectedColor,
      textColor: textColor,
      textSecondaryColor: textSecondaryColor
    }),
    SpacerVertical: SpacerVertical({
      spacerColor: spacerColor
    }),
    SwitchCheckbox: SwitchCheckbox({
      borderColor: borderColor,
      borderSelectedColor: borderSelectedColor,
      checkboxColor: checkboxColor,
      textColor: textColor
    }),
    SwitchToggle: SwitchToggle({
      checkboxColor: checkboxColor,
      checkboxCheckmarkColor: checkboxCheckmarkColor,
      textColor: textColor
    }),
    TitleSecondary: TitleSecondary({
      headerColor: headerColor
    }),
    Tooltip: Tooltip({
      borderRadius: borderRadius
    })
  }, customOverrides && customOverrides({
    customizations: customizations,
    borderRadius: borderRadius,
    buttonColor: buttonColor,
    buttonColorHovered: buttonColorHovered,
    buttonColorPressed: buttonColorPressed,
    buttonTextColor: buttonTextColor,
    buttonTextColorHovered: buttonTextColorHovered,
    buttonTextColorPressed: buttonTextColorPressed,
    borderSelectedColor: borderSelectedColor,
    borderColor: borderColor,
    checkboxColor: checkboxColor,
    checkboxCheckmarkColor: checkboxCheckmarkColor,
    linkColor: linkColor,
    detailsColor: detailsColor,
    headerColor: headerColor,
    textColor: textColor,
    textSecondaryColor: textSecondaryColor
  }));

  return /*#__PURE__*/React.createElement(StyleSheetOverridesProvider, overrides, /*#__PURE__*/React.createElement(SetThemeInContext, {
    theme: theme
  }, children));
};

ThemeProvider.displayName = 'ThemeProvider';
export default ThemeProvider;
export var withTheme = getContext({
  theme: PropTypes.object
});
export var useTheme = function useTheme() {
  return React.useContext(ThemeContext);
};
//# sourceMappingURL=index.js.map